<section class="kpi" *ngFor="let kpi of kpis">
  <i class="kpi-icon fa" [ngClass]="kpi.icon" aria-hidden="true"></i>
  <h2>{{ kpi.label }}</h2>
  <div class="kpi-value" [ngClass]="kpi.color">
    {{ getValue(kpi.field) === null ? '—' : (getValue(kpi.field) | number:kpi.digits:'en-US') }}
  </div>
  <p>{{ kpi.description }}</p>
</section>
